import Vue from 'vue'
import { wtQueue, wtAccepted, wtConflicted } from '@/walkthroughs/wtData'
import router from '../../router'
import { convertType } from '@/helpers/type-converter'

export const subscriptions = {
    state: {
        status: 'idle',
        subscriptions: null,
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        search: {
            search: '',
            query: {},
            advanced: null
        },
        selectAllSubscriptions: false,
        selectedSubscriptions: [],
        subscriptionsQueue: {
            all: 0,
            accepted: {
                count: 0
            },
            error: {
                count: 0
            },
            waiting: {
                count: 0
            }
        },
        queueStatus: 'idle',
        conflictedSubscriptions: [],
        acceptedSubscriptions: [],
        subscriptionsToStop: [],
        selectSubsToStop: true,
        progress: null,
        queueId: null,
        processedSubscriptions: {
            accepted: {
                status: 'idle',
                pagination: null,
                promos: null
            },
            interrupted: {
                status: 'idle',
                pagination: null,
                promos: null
            },
            error: {
                status: 'idle',
                pagination: null,
                promos: null
            },
            total: null
        },
        generatedLabelsStatus: 'idle',
        subscriptionLocalCodeErrors: []
    },
    mutations: {
        SET_GENERATED_LABELS_STATUS(state, status) {
            state.generatedLabelsStatus = status
        },
        SET_SUBSCRIPTIONS_STATUS(state, status) {
            state.status = status
        },
        SET_QUEUE_STATUS(state, status) {
            state.queueStatus = status
        },
        SET_SUBSCRIPTIONS(state, subscriptions) {
            state.subscriptions = subscriptions
        },
        SET_SELECTED_SUBSCRIPTIONS(state, payload) {
            state.selectedSubscriptions = payload
        },
        SET_SELECT_ALL_SUBSCRIPTIONS(state, payload) {
            state.selectAllSubscriptions = payload
        },
        SET_SUBSCRIPTIONS_QUEUE(state, payload) {
            state.subscriptionsQueue = payload
        },
        RESET_QUEUE(state, payload) {
            Vue.set(state, 'subscriptionsQueue', payload)
        },
        SET_CONFLICTED_SUBSCRIPTIONS(state, payload) {
            state.conflictedSubscriptions = payload
        },
        SET_ACCEPTED_SUBSCRIPTIONS(state, payload) {
            state.acceptedSubscriptions = payload
        },
        SET_SELECTED_SUBS_TO_STOP(state, payload) {
            state.subscriptionsToStop = payload
        },
        SET_SELECT_SUBS_TO_STOP(state, payload) {
            state.selectSubsToStop = payload
        },
        SET_SUBSCRIPTIONS_PROGRESS(state, payload) {
            state.progress = payload
        },
        SET_SUBSCRIPTIONS_QUEUEID(state, payload) {
            state.queueId = payload
        },
        SET_PROCESSED_SUBSCRIPTIONS(state, payload) {
            state.processedSubscriptions = payload
        },
        SET_PROCESSED_SUBSCRIPTIONS_TOTAL(state, payload) {
            state.processedSubscriptions.total = payload
        },
        SET_SUBSCRIPTION_LOCAL_CODE_ERRORS(state, payload) {
            state.subscriptionLocalCodeErrors = payload
        }
    },
    actions: {
        setGeneratedLabelsStatus({ commit }, payload) {
            commit('SET_GENERATED_LABELS_STATUS', payload)
        },
        async getAllProcessedSubsData({ state }) {
            return this.$api.get(`subscriptionStatus/${state.queueId}/successed`, {
                params: {
                    perPage: 99999,
                    page: 1
                }
            })
        },
        selectAllSubscriptions({ commit, getters }, payload) {
            let promoProducts = getters.getPromotion

            if (promoProducts.products.length > 0) {
                promoProducts = promoProducts.products
            } else if (promoProducts.product_sets.length > 0) {
                promoProducts = promoProducts.product_sets.map(
                    el => el.product_set_dict_products
                )[0]
            }
            promoProducts = promoProducts.map(item => {
                return {
                    productName: item.dict_product.name,
                    productId: item.id,
                    productPrice: null,
                    productMaxPrice: item.maximum_price
                        ? item.maximum_price
                        : null
                }
            })

            let promoSubs = getters.getPromotion.subscriptions
            if (promoSubs) {
                promoSubs = promoSubs
                    .filter(el => el.state === 'available')
                    .map(el => {
                        return {
                            ...el,
                            checked: payload,
                            products: promoProducts
                        }
                    })
            }

            const promotions = []
            promotions.push({
                promoId: getters.getPromotion.id,
                subscriptions: promoSubs,
                merchants: getters.getMerchantIds
            })
            commit('SET_SELECTED_PROMOTIONS', promotions)

            // if payload is true, select all
            if (payload) {
                commit(
                    'SET_SELECTED_SUBSCRIPTIONS',
                    getters.getFilteredSubscriptions
                        .filter(item => item.status === 'available')
                        .map(item => item.id)
                )
            } else {
                commit('SET_SELECTED_SUBSCRIPTIONS', [])
            }
        },
        setSelectAllSubscriptions({ commit }, payload) {
            commit('SET_SELECT_ALL_SUBSCRIPTIONS', payload)
        },
        subscriptionsFetch({ state, commit }, query = {}) {
            const { params, suspended } = query
            if (state.status === 'idle') {
                commit('SET_SUBSCRIPTIONS_STATUS', 'loading')
                return this.$api
                    .get('subscriptions', {
                        params: {
                            ...params,
                            promo_id: query.promoId,
                            includes: query.includes,
                            per: params.per || 99999,
                            suspended
                        }
                    })
                    .then(response => {
                        commit('SET_SUBSCRIPTIONS', response.data.data)
                        commit('SET_SUBSCRIPTIONS_STATUS', 'idle')
                        return response.data.data
                    })
                    .catch(error => {
                        commit('SET_SUBSCRIPTIONS_STATUS', 'idle')
                        console.log(error)
                    })
            }
        },
        setSubscriptionsStatus({ commit }, payload) {
            commit('SET_SUBSCRIPTIONS_STATUS', payload)
        },
        clearQueue({ commit }) {
            this.$storage.getItem('initialState').then(response => {
                commit('RESET_QUEUE', response.subscriptions.subscriptionsQueue)
            })
        },
        subscriptionsQueue({ state, getters, dispatch, commit }, payload) {
            if (getters.getWalkthroughActive) {
                commit('SET_SUBSCRIPTIONS_QUEUE', wtQueue)
                return
            }
            if (state.queueStatus !== 'idle') {
                return
            }
            commit('SET_SUBSCRIPTIONS_STATUS', 'loading')
            commit('SET_QUEUE_STATUS', 'loading')
            const context = this
            const selectedPromosCopy = [...getters.getSelectedPromotions]
            const selectedPromoGroups = getters.getSelectedPromoGroups
            const subscriptionGroups = []
            const interrupt = payload?.state === 'interrupted'

            const altEansToSave = []
            const altEansToUpdate = []

            const pushAltEans = (product, sub) => {
                if (product.alternativeEan && product.eanErrors?.length) {
                    const err = product.eanErrors.find(er => {
                        return (
                            product.alternativeEan === er.alternative_ean &&
                            sub.merchant_id === er.merchant_id
                        )
                    })
                    if (err) {
                        altEansToUpdate.push({
                            id: err.id,
                            alternative_ean: product.alternativeEan
                        })
                    } else {
                        altEansToSave.push({
                            merchant_id: sub.merchant_id,
                            alternative_ean: product.alternativeEan,
                            dict_product_id: product.dict_product.id
                        })
                    }
                } else if (product.alternativeEan) {
                    altEansToSave.push({
                        merchant_id: sub.merchant_id,
                        alternative_ean: product.alternativeEan,
                        dict_product_id: product.dict_product.id
                    })
                }
            }

            selectedPromoGroups.forEach(selectedGroup => {
                const merchantIds = interrupt
                    ? getters.getSubscriptionsToStop
                        .filter(el => el.checked)
                        .map(el => el.merchant_id)
                    : selectedGroup.merchantIds
                        .filter(el => el.selected)
                        .map(el => el.id)
                const groupObj = {
                    id: selectedGroup.id,
                    merchant_ids: merchantIds,
                    acceptance: selectedGroup.acceptance
                }

                const promoSubscriptions = []
                let promoSubscriptionWithProductPrice = []

                selectedGroup.promos.forEach(promo => {
                    if (!promo.selected) return
                    const subs = getters
                        .getSubscriptionsByPromo(promo)
                        .map(el => {
                            return {
                                ...el,
                                promo_id: promo.id
                            }
                        })
                    const noSubsSelected = subs.every(
                        sub => sub.checked === false
                    )
                    const nonInterruptedPromoSubscriptions = subs.filter(el => {
                        return el.state !== 'interrupted'
                    })
                    if (noSubsSelected) {
                        promoSubscriptions.push(...nonInterruptedPromoSubscriptions)
                    } else {
                        promoSubscriptions.push(
                            ...nonInterruptedPromoSubscriptions.filter(sub => sub.checked)
                        )
                    }
                })

                if (interrupt) {
                    Object.assign(groupObj, {
                        subscriptions: getters.getSubscriptionsToStop
                            .filter(sub => sub.checked)
                            .map(sub => {
                                return {
                                    id: sub.id,
                                    merchant_id: sub.merchant_id,
                                    promo_id: sub.promo_id,
                                    state: sub.state
                                }
                            })
                    })
                } else {
                    // default use case - select single promotions
                    promoSubscriptionWithProductPrice = promoSubscriptions.map(
                        sub => {
                            let products = []
                            let productSets = []

                            // If selected promotions products have prices, send product id & price
                            if (sub.products && sub.products.length > 0) {
                                products = sub.products.map(el => {
                                    pushAltEans(el, sub)

                                    const pSubscriptions = (el.product_subscriptions || [])
                                    const productSubscriptions = pSubscriptions.find(s => s.subscription_id === sub.id)

                                    return {
                                        alternative_ean: el.alternativeEan
                                            ? el.alternativeEan
                                            : '',
                                        promo_dict_product_id: el.id,
                                        price: el.productPrice
                                            ? parseFloat(el.productPrice)
                                            : parseFloat(el.productMaxPrice),
                                        id: productSubscriptions?.id // id = promo_dict_product_subscription_id
                                    }
                                })
                            } else if (
                                sub.product_sets &&
                                sub.product_sets.length > 0
                            ) {
                                productSets = sub.product_sets
                                    .filter(
                                        item =>
                                            item.price !== null &&
                                            item.price !== ''
                                    )
                                    .map(el => {
                                        return {
                                            id: sub.product_set_subscriptions?.length
                                                ? sub.product_set_subscriptions[0].id
                                                : undefined,
                                            product_set_id: el.id,
                                            price: parseFloat(el.price)
                                        }
                                    })
                            }

                            if (products[0] === undefined) {
                                products = []
                            }

                            return {
                                id: sub.id,
                                merchant_id: sub.merchant_id,
                                products,
                                product_sets: productSets,
                                promo_id: sub.promo_id,
                                state: sub.state
                            }
                        }
                    )
                    // end default use case

                    // use case: select whole group, some products has prices
                    // if (selectedGroup.selectWholeGroup) {
                    //     promoSubscriptionWithProductPrice =
                    //        promoSubscriptionWithProductPrice.filter(
                    //             promoSub =>
                    //                 !!promoSub.products.length ||
                    //                 !!promoSub.product_sets.length
                    //        )
                    // }
                    // end use case

                    // use case: select whole group, some promos excepted
                    if (selectedGroup.selectWholeGroup) {
                        const exceptedPromos = selectedGroup.promos
                            .filter(promo => promo.selected === false)
                            .map(promo => promo.id)

                        if (exceptedPromos.length) {
                            Object.assign(groupObj, {
                                excepted_promotions: exceptedPromos
                            })
                        }
                    }
                    // end use case

                    if (promoSubscriptionWithProductPrice.length > 0) {
                        Object.assign(groupObj, {
                            subscriptions: promoSubscriptionWithProductPrice
                        })
                    }
                }
                groupObj.promo_ids = selectedGroup.selectedPromoIds
                subscriptionGroups.push(groupObj)
            })

            if (altEansToSave.length) {
                this.$api.post('saveMerchantAlternativeEans', {
                    save: altEansToSave
                })
            }

            return this.$api
                .patch('subscriptionUpdate', {
                    userId: getters.userId,
                    groups: subscriptionGroups,
                    state: payload.state
                })
                .then(res => {
                    if (interrupt) {
                        commit('SET_SUBSCRIPTIONS_STATUS', 'idle')
                        commit('SET_QUEUE_STATUS', 'idle')
                        return res
                    }
                    const response = res.data.data
                    const queueId = response.queue_id
                    commit('SET_SUBSCRIPTIONS_QUEUEID', queueId)
                    commit('SET_PROCESSED_SUBSCRIPTIONS_TOTAL', null)

                    function checkProgress() {
                        context.$api
                            .get(`subscriptionQueueProgress/${queueId}`)
                            .then(res => {
                                commit(
                                    'SET_SUBSCRIPTIONS_PROGRESS',
                                    res.data.data
                                )
                                commit(
                                    'SET_PROCESSED_SUBSCRIPTIONS_TOTAL',
                                    res.data.data.total
                                )
                            })
                    }

                    setTimeout(() => {
                        checkProgress()
                    }, 1000)

                    setTimeout(() => {
                        const timer = setInterval(async function() {
                            const isModalOn = getters.isModalOn

                            if (!isModalOn) {
                                // If user closed modal, stop processing
                                commit('SET_QUEUE_STATUS', 'idle')
                                clearInterval(timer)
                                return
                            }

                            const { status } = state.progress

                            if (status === 'waiting' || status === 'processing') {
                                // Data is still processing, check progress again
                                checkProgress()
                                return
                            }

                            // Processing is done
                            commit('SET_QUEUE_STATUS', 'idle')
                            clearInterval(timer)

                            await dispatch('fetchAcceptedSubscriptions')
                            await dispatch('fetchErrorSubscriptions')
                            await dispatch('conflictedSubscriptionsFetch')
                            await dispatch('acceptedSubscriptionsFetch')
                            await dispatch('setSubscriptionsStatus', 'idle')

                            const { promoId } = (getters.modalState || {}).args || {}
                            if (promoId) {
                                dispatch('loadPromotion', { promoId })
                            } else {
                                dispatch('loadPromoGroups')
                            }

                            // Clear progress
                            setTimeout(() => {
                                commit('SET_SUBSCRIPTIONS_PROGRESS', null)
                            }, 2000)

                            /* GTAG send accepted promos */
                            const accepted = (state.subscriptionsQueue || {}).accepted || {}
                            if (accepted.count > 0 && accepted.promos.length > 0) {
                                const acceptedPromoIds = accepted.promos.map(
                                    el => el.id
                                )
                                const acceptedPromos = selectedPromosCopy.filter(
                                    el => acceptedPromoIds.includes(el.id)
                                )

                                Vue.$gtag.event('purchase', {
                                    transaction_id: new Date().valueOf().toString(),
                                    affiliation: '',
                                    value: 0,
                                    currency: 'PLN',
                                    tax: 0,
                                    shipping: 0,
                                    items: acceptedPromos.map(el => {
                                        return {
                                            name: el.name,
                                            id: el.id.toString(),
                                            list_name: 'Lista',
                                            price: '1',
                                            brand: 'Producent',
                                            quantity: 1
                                        }
                                    })
                                })
                            }
                        }, 1000)
                    }, 1000)
                })
                .catch(error => {
                    commit('SET_SUBSCRIPTIONS_STATUS', 'idle')
                })
        },
        conflictedSubscriptionsFetch({ commit, getters }) {
            if (getters.getWalkthroughActive) {
                commit('SET_CONFLICTED_SUBSCRIPTIONS', [wtConflicted[0]])
                return
            }
            const error = getters.getSubscriptionsQueue.error
            if (error.count > 0 && Object.values(error.promos).length > 0) {
                const subscriptionIds = Object.values(error.promos)
                    .map(el => el.subscription_id)
                    .join(',')

                return this.$api
                    .get(
                        `subscriptions?id=${subscriptionIds}&includes=subscription,subscription.promo,promo.company,subscription.merchant`,
                        {
                            params: {
                                per: 99999
                            }
                        }
                    )
                    .then(response => {
                        commit(
                            'SET_CONFLICTED_SUBSCRIPTIONS',
                            response.data.data
                        )
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        },
        acceptedSubscriptionsFetch({ commit, getters }) {
            if (getters.getWalkthroughActive) {
                commit('SET_ACCEPTED_SUBSCRIPTIONS', [wtAccepted[0]])
                return
            }
            const accepted = getters.getSubscriptionsQueue.accepted
            if (
                accepted.count > 0 &&
                Object.values(accepted.promos).length > 0
            ) {
                const subscriptionIds = Object.values(accepted.promos)
                    .map(el => el.subscription_id)
                    .join(',')

                return this.$api
                    .get(
                        `subscriptions?id=${subscriptionIds}&includes=subscription,subscription.promo,promo.company,subscription.merchant`,
                        {
                            params: {
                                per: 99999
                            }
                        }
                    )
                    .then(response => {
                        commit('SET_ACCEPTED_SUBSCRIPTIONS', response.data.data)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        },
        selectAllSubsToStop({ state, commit }, payload) {
            if (state.subscriptions) {
                const subs = state.subscriptions
                    .filter(item => {
                        return item.state === 'accepted'
                    })
                    .map(item => {
                        return { ...item, checked: payload }
                    })
                commit('SET_SELECTED_SUBS_TO_STOP', subs)
            }
        },
        selectSubToStop({ state, commit }, payload) {
            const subscriptions = state.subscriptionsToStop
            const subscription = subscriptions.find(el => {
                return el.id === payload.id
            })
            subscription.checked = payload.value

            commit('SET_SELECTED_SUBS_TO_STOP', subscriptions)
            commit('SET_SELECT_SUBS_TO_STOP', false)
        },
        setSelectAllSubsToStop({ commit }, payload) {
            commit('SET_SELECT_SUBS_TO_STOP', payload)
        },
        selectSubscription({ commit, getters }, payload) {
            const selectedPromotion = getters.getSelectedPromotions.find(
                el => el.id === payload.promoId
            )
            if (selectedPromotion) {
                const subscription = selectedPromotion.subscriptions.find(
                    el => el.id === payload.subscriptionId
                )
                subscription.checked = payload.value
                commit('SET_SELECTED_PROMOTIONS', [selectedPromotion])
            } else {
                const promotion = getters.getPromotion

                let products = []
                let productSets = []

                if (promotion.products.length > 0) {
                    products = promotion.products
                    products = products.map(item => {
                        return {
                            productName: item.dict_product.name,
                            productId: item.id,
                            productPrice: null,
                            productMaxPrice: item.maximum_price
                                ? item.maximum_price
                                : null
                        }
                    })
                } else if (promotion.product_sets.length > 0) {
                    productSets = promotion.product_sets.map(el => {
                        return {
                            id: el.id,
                            price: null,
                            maxPrice: el.price
                        }
                    })
                }

                const subs = promotion.subscriptions
                    .filter(el => el.state === 'available')
                    .map(el => {
                        if (el.id === payload.subscriptionId) {
                            return {
                                ...el,
                                checked: true,
                                products,
                                product_sets: productSets
                            }
                        } else {
                            return {
                                ...el,
                                checked: false,
                                products,
                                product_sets: productSets
                            }
                        }
                    })
                commit('SET_SELECTED_PROMOTIONS', [
                    { ...promotion, subscriptions: subs }
                ])
            }
        },
        setSubscriptionAlternativeEan({ commit, dispatch, getters }, payload) {
            let searchedPromo
            let selectedGroups
            let commitName
            if (payload.fromLabels) {
                selectedGroups = JSON.parse(
                    JSON.stringify(getters.getSelectedLabelGroups)
                )
                commitName = 'SET_SELECTED_LABELGROUPS'
            } else {
                selectedGroups = JSON.parse(
                    JSON.stringify(getters.getSelectedPromoGroups)
                )
                commitName = 'SELECT_PROMOGROUP'
            }
            const group = selectedGroups.find(
                group => group.id === payload.groupId
            )
            if (group) {
                searchedPromo = group.promos.find(
                    promo => promo.id === payload.promoId
                )
            }

            let searchedSubscription
            if (payload.promo.equalLocalCodes) {
                searchedSubscription = searchedPromo.subscriptionsEqualPrices.priceGroups[
                    payload.groupIdx || 0
                ].forEach(el => {
                    el.products.forEach(product => {
                        if (product.productId === payload.productId) {
                            product.alternativeEan = payload.alternativeEan
                        }
                    })
                })
            } else {
                searchedSubscription = searchedPromo.subscriptions.find(
                    el => el.merchant_id === payload.merchantId
                )

                const searchedProduct = searchedSubscription.products.find(
                    el => el.productId === payload.productId
                )

                searchedProduct.productPrice = payload.productPrice

                Vue.set(
                    searchedProduct,
                    'alternativeEan',
                    payload.alternativeEan
                )
            }
            commit(commitName, selectedGroups)
        },
        setSubscriptionProductPrice({ commit, getters }, payload) {
            const { product, groupId, newPrice, promo, groupIdx, merchantId, fromLabels } = payload
            const productId = product.id

            const selectedGroups = fromLabels
                ? getters.getSelectedLabelGroupsJson
                : getters.getSelectedPromoGroupsJson

            const group = selectedGroups.find(({ id }) => id === groupId)
            const searchedPromo = group.promos.find(({ id }) => id === promo.id)

            const setProductPrice = (products, equalPrices) => {
                const product = products.find(prod => prod.id === productId)
                Vue.set(product, 'productPrice', +newPrice)

                if (equalPrices) {
                    Vue.set(product, 'price_default', +newPrice)
                }
            }

            setProductPrice(searchedPromo.products)

            if (promo.subscriptionsEqualPrices.equalPrices) {
                for (const subscription of searchedPromo.subscriptionsEqualPrices.priceGroups[groupIdx]) {
                    setProductPrice(subscription.products, true)
                }
            } else {
                const subscription = searchedPromo.subscriptions.find(
                    el => el.merchant_id === merchantId
                )
                setProductPrice(subscription.products)
            }

            if (fromLabels) {
                commit('SET_SELECTED_LABELGROUPS', selectedGroups)
            } else {
                commit('SELECT_PROMOGROUP', selectedGroups)
            }
        },
        setProductShowExtraFields({ commit, getters }, payload) {
            const { showExtraFields } = payload
            let searchedPromo = null
            const selectedGroups = getters.getSelectedLabelGroupsJson
            const group = selectedGroups.find(
                group => group.id === payload.groupId
            )
            if (group) {
                searchedPromo = group.promos.find(
                    promo => promo.id === payload.promoId
                )
            }
            const searchedProduct = searchedPromo.products.find(
                prod => prod.id === payload.productId
            )

            let searchedSubscription
            if (searchedPromo.subscriptionsEqualPrices.equalPrices) {
                searchedSubscription = searchedPromo.subscriptionsEqualPrices.priceGroups[
                    payload.groupIdx
                ].forEach(el => {
                    el.products.forEach(prod => {
                        if (
                            prod.promo_dict_product_id ===
                                searchedProduct.promo_dict_product_id ||
                            prod.productId === payload.productId
                        ) {
                            Vue.set(prod, 'showExtraFields', showExtraFields)
                        }
                    })
                })

                searchedPromo.subscriptions.forEach(sub => {
                    sub.products.forEach(prod => {
                        if (
                            prod.promo_dict_product_id ===
                                searchedProduct.promo_dict_product_id ||
                            prod.productId === payload.productId
                        ) {
                            Vue.set(prod, 'showExtraFields', showExtraFields)
                        }
                    })
                })
            } else {
                searchedSubscription = searchedPromo.subscriptions.find(
                    el => el.merchant_id === payload.merchantId
                )

                const searchedProducts = searchedSubscription.products.filter(
                    el =>
                        el.promo_dict_product_id ===
                            searchedProduct.promo_dict_product_id ||
                        el.productId === payload.productId
                )

                searchedProducts.forEach(prod => {
                    Vue.set(prod, 'showExtraFields', showExtraFields)
                })
            }
            commit('SET_SELECTED_LABELGROUPS', selectedGroups)
        },
        setSubscriptionProductCopies({ commit, getters }, payload) {
            const { groupId, promoId, product, copies, groupIdx = -1, merchantId } = payload
            const productId = product.id

            const selectedGroups = getters.getSelectedLabelGroupsJson
            const group = selectedGroups.find(({ id }) => id === groupId)
            if (!group) return
            const searchedPromo = group.promos.find(({ id }) => id === promoId)
            if (!searchedPromo) return

            const setProductCopies = (products) => {
                // If product has dict_product, it means it's a main product
                if (product.dict_product) {
                    const product = products.find(prod => prod.id === productId)
                    Vue.set(product, 'print_copies', copies)
                    return
                }

                const mainProduct = products.find(
                    p => p.id === product.promo_dict_product_id
                )

                if (!mainProduct) {
                    return
                }

                if (!Array.isArray(mainProduct.subProducts)) {
                    Vue.set(mainProduct, 'subProducts', [])
                }

                // Check if the subProduct already exists in order to avoid duplicates
                const subProduct = mainProduct.subProducts.find(({ id }) => id === product.id)

                if (!subProduct) {
                    mainProduct.subProducts.push({
                        ...product,
                        print_copies: copies
                    })
                } else {
                    Vue.set(subProduct, 'print_copies', copies)
                }
            }

            setProductCopies(searchedPromo.products)

            // Aktualizacja kopii w subscriptionsEqualPrices, jeśli dotyczy
            if (groupIdx > -1 && searchedPromo.subscriptionsEqualPrices?.priceGroups) {
                const priceGroups = searchedPromo.subscriptionsEqualPrices.priceGroups[groupIdx]

                priceGroups.forEach(el => {
                    setProductCopies(el.products || [])
                })

                // Aktualizacja kopii w subscriptions
                searchedPromo.subscriptions.forEach(sub => {
                    setProductCopies(sub.products || [])
                })
            } else if (searchedPromo.subscriptions) {
                // Standardowa aktualizacja dla pojedynczego subskrybenta
                const searchedSubscription = searchedPromo.subscriptions.find(
                    el => el.merchant_id === merchantId
                )
                setProductCopies(searchedSubscription.products || [])
            }

            commit('SET_SELECTED_LABELGROUPS', selectedGroups)
        },
        setSubscriptionProductPriceLowest({ commit, getters }, payload) {
            const { groupId, promo, groupIdx, merchantId, product } = payload
            const productId = product.id

            const selectedGroups = getters.getSelectedLabelGroupsJson
            const group = selectedGroups.find(({ id }) => id === groupId)
            const searchedPromo = group.promos.find(({ id }) => id === promo.id)

            const setPriceLowest = (products) => {
                const product = products.find(prod => prod.id === productId)
                if (product) {
                    Vue.set(product, 'price_lowest', +payload.priceLowest)
                }
            }

            setPriceLowest(searchedPromo.products)

            if (promo.subscriptionsEqualPrices.equalPrices) {
                for (const subscription of searchedPromo.subscriptionsEqualPrices.priceGroups[groupIdx]) {
                    setPriceLowest(subscription.products)
                }
            } else {
                const subscription = searchedPromo.subscriptions.find(
                    el => el.merchant_id === merchantId
                )
                setPriceLowest(subscription.products)
            }

            commit('SET_SELECTED_LABELGROUPS', selectedGroups)
        },
        setSubscriptionProductFreshAttribute({ commit, getters }, payload) {
            const { groupId, groupIdx, productId, merchantId, promoId, attribute, value } = payload
            const groups = getters.getSelectedLabelGroups
            const group = groups.find(group => group.id === groupId)

            const typedValue = convertType(value, attribute.type)

            if (group) {
                const searchedPromo = group.promos.find(
                    promo => promo.id === promoId
                )

                if (groupIdx > -1) {
                    searchedPromo.subscriptionsEqualPrices.priceGroups[groupIdx].forEach(el => {
                        el.products.forEach(product => {
                            if (product.id === productId) {
                                if (!product.payload) product.payload = {}
                                product.payload[attribute.name] = typedValue
                            }
                        })
                    })
                } else {
                    const searchedSubscription = searchedPromo.subscriptions.find(
                        el => el.merchant_id === merchantId
                    )

                    const searchedProduct = searchedSubscription.products.find(
                        el => el.id === productId
                    )
                    if (!searchedProduct.payload) searchedProduct.payload = {}
                    searchedProduct.payload[attribute.name] = typedValue
                }

                commit('SET_SELECTED_LABELGROUPS', null)
                commit('SET_SELECTED_LABELGROUPS', groups)
            }
        },

        setSubscriptionProductSetPrice({ commit, dispatch, getters }, payload) {
            const groups = getters.getSelectedPromoGroups
            const group = groups.find(e => e.id === payload.groupId)
            const searchedPromo = group.promos.find(
                e => e.id === payload.promoId
            )

            let searchedSubscription
            if (payload.groupIdx > -1) {
                searchedSubscription = searchedPromo.subscriptionsEqualPrices.priceGroups[
                    payload.groupIdx
                ].forEach(el => {
                    el.product_sets.forEach(set => {
                        if (set.id === payload.setId) {
                            set.price = payload.setPrice
                        }
                    })
                })
            } else {
                searchedSubscription = searchedPromo.subscriptions.find(
                    el => el.merchant_id === payload.merchantId
                )
                const searchedProduct = {
                    ...searchedSubscription.product_sets.find(
                        el => el.id === payload.setId
                    )
                }
                const searchedRestProducts = [
                    ...searchedSubscription.product_sets.filter(
                        el => el.id !== payload.setId
                    )
                ]
                Vue.set(searchedSubscription, 'product_sets', [
                    ...searchedRestProducts,
                    searchedProduct
                ])
                Vue.set(searchedProduct, 'price', payload.setPrice)
            }
            commit('SELECT_PROMOGROUP', groups)
        },

        async fetchSubscriptions({ dispatch }, { params, config = {} }) {
            try {
                const res = await this.$api.get('subscriptions', {
                    params,
                    config
                })

                if (res.status !== 200 || !res.data?.data) {
                    throw new Error(res.data?.message || 'Error GET subscriptions')
                }

                if (config.productSubscriptions) {
                    // fetchProductSubscriptions
                    const ps = await dispatch('fetchProductSubscriptions', {
                        params: {
                            'subscription|promo_id': params.promo_id,
                            per: 99999
                        },
                        config: {
                            noCancel: true
                        }
                    })

                    for (const sub of res.data.data) {
                        const productSubscriptions = (ps || []).filter(
                            el => el.subscription_id === sub.id
                        )

                        sub.product_subscriptions = productSubscriptions
                    }
                }

                return res
            } catch (err) {
                console.log(err)
            }
        },

        async fetchSubscriptionsByPromoId({ dispatch, getters }, payload) {
            const { promos } = payload

            if (!promos.length) {
                return []
            }

            const routeName = router.currentRoute.name

            const merchants =
                routeName === 'promo-finished'
                    ? getters.getMerchants
                    : getters.getAvailableMerchants

            // Build request payload
            const params = {
                per: 99999,
                promo_id: promos.map(el => el.id).join(),
                includes: 'merchant',
                merchant_id: merchants.map(el => el.id).join(),
                state: payload.state,
                'merchant|nip': payload['merchant|nip']
            }

            // If not 'promo-finished', add the suspended param
            if (routeName !== 'promo-finished') {
                params.suspended = false
            }

            try {
                const { status, data } = await dispatch('fetchSubscriptions', {
                    params,
                    config: {
                        productSubscriptions: true,
                        productSetSubscriptions: true,
                        noCancel: true
                    }
                })

                if (status !== 200 || !data?.data) {
                    throw new Error(data?.message || 'Error GET subscriptions')
                }

                // Map subscriptions to promos
                const filteredSubs = data.data.reduce((h, s) => {
                    // Take only needed fields
                    const sub = {
                        id: s.id,
                        merchant_id: s.merchant_id,
                        state: s.state,
                        suspended: s.suspended,
                        updated_at: s.updated_at,
                        product_set_subscriptions: s.product_set_subscriptions,
                        product_subscriptions: s.product_subscriptions,
                        company_merchant_status: s.company_merchant_status,
                        merchant_network_id: s.merchant.network_id
                    }
                    return Object.assign(h, {
                        [s.promo_id]: (h[s.promo_id] || []).concat(sub)
                    })
                }, {})

                // Return promos with subscriptions
                return promos.map(item => ({
                    ...item,
                    subscriptions: filteredSubs[item.id],
                    subscriptionsEqualPrices: {
                        equalPrices: payload.equalPrices ?? false,
                        priceGroups: [filteredSubs[item.id]]
                    },
                    selected: payload.selected ?? false
                }))
            } catch (err) {
                console.log(err)
            }

            return this.$api
                .get('subscriptions', {
                    params,
                    config: {
                        noCancel: true
                    }
                })
                .then(res => {
                    const filteredSub = res.data.data
                        .map(sub => {
                            return {
                                subId: sub.id,
                                merchant_id: sub.merchant_id,
                                id: sub.promo_id,
                                state: sub.state,
                                suspended: sub.suspended,
                                updated_at: sub.updated_at,
                                product_set_subscriptions:
                                    sub.product_set_subscriptions,
                                product_subscriptions:
                                    sub.product_subscriptions,
                                company_merchant_status:
                                    sub.company_merchant_status,
                                merchant_network_id: sub.merchant.network_id
                            }
                        })
                        .reduce(
                            (h, sub) =>
                                Object.assign(h, {
                                    [sub.id]: (h[sub.id] || []).concat({
                                        id: sub.subId,
                                        merchant_id: sub.merchant_id,
                                        state: sub.state,
                                        suspended: sub.suspended,
                                        updated_at: sub.updated_at,
                                        product_set_subscriptions:
                                            sub.product_set_subscriptions,
                                        product_subscriptions:
                                            sub.product_subscriptions,
                                        company_merchant_status:
                                            sub.company_merchant_status,
                                        merchant_network_id:
                                            sub.merchant_network_id
                                    })
                                }),
                            {}
                        )

                    const mappedPromos = payload.promosData.map(item =>
                        Object.assign(
                            {},
                            item,
                            { marketingPromoConflict: false },
                            { subscriptions: filteredSub[item.id] },
                            {
                                subscriptionsEqualPrices: {
                                    equalPrices: payload.equalPrices || false,
                                    priceGroups: [filteredSub[item.id]]
                                }
                            },
                            {
                                productsStatus: 'idle',
                                productsPagination: null,
                                selected:
                                    payload.selected !== undefined
                                        ? payload.selected
                                        : false,
                                products: [],
                                productSets: []
                            }
                        )
                    )

                    return mappedPromos
                })
                .catch(err => {
                    console.log(err)
                })
        },
        fetchAcceptedSubscriptions({ dispatch }, payload) {
            return dispatch('fetchProcessedSubscriptions', {
                ...payload,
                type: 'successed',
                status: 'accepted'
            })
        },
        fetchInterruptedSubscriptions({ dispatch }, payload) {
            return dispatch('fetchProcessedSubscriptions', {
                ...payload,
                type: 'successed',
                status: 'interrupted'
            })
        },
        fetchErrorSubscriptions({ dispatch }, payload) {
            return dispatch('fetchProcessedSubscriptions', {
                ...payload,
                type: 'error',
                status: 'error'
            })
        },
        async fetchProcessedSubscriptions({ state, commit }, payload) {
            const queueId = state.queueId || payload.queueId
            const { type, status, perPage = 10, page = 1 } = payload
            const processedSubs = JSON.parse(
                JSON.stringify(state.processedSubscriptions)
            )
            processedSubs[status].status = 'loading'
            commit('SET_PROCESSED_SUBSCRIPTIONS', processedSubs)

            try {
                const res = await this.$api.get(
                    `subscriptionStatus/${queueId}/${type}`,
                    {
                        params: {
                            perPage,
                            page
                        }
                    }
                )
                if (res?.data) {
                    processedSubs[status].promos = res.data.data[status].promos
                    processedSubs[status].pagination = res.data.pagination[0]
                    return res
                }
            } catch (err) {
                console.log(err)
            } finally {
                processedSubs[status].status = 'idle'
                commit('SET_PROCESSED_SUBSCRIPTIONS', processedSubs)
            }
        },
        async setProcessedSubscriptions({ commit }, payload) {
            commit('SET_PROCESSED_SUBSCRIPTIONS', payload)
        },
        async resetProcessedSubscriptions({ commit }) {
            const initState = await this.$storage.getItem('initialState')
            commit(
                'SET_PROCESSED_SUBSCRIPTIONS',
                initState.subscriptions.processedSubscriptions
            )
        },
        async fetchSubscriptionResources(_, payload) {
            try {
                return await this.$api.get(
                    'promo_dict_product_subscriptions_extended',
                    {
                        params: {
                            ...payload,
                            per: payload.per || 99999
                        },
                        config: {
                            noCancel: true
                        }
                    }
                )
            } catch (err) {
                console.log(err)
            }
        },
        setSubscriptionLocalCodeErrors({ commit }, payload) {
            commit('SET_SUBSCRIPTION_LOCAL_CODE_ERRORS', payload)
        }
    },
    getters: {
        getSubscriptions: state => {
            if (state.subscriptions) {
                return state.subscriptions
            }
        },
        getSubscriptionsStatus: state => {
            return state.status
        },
        getSubscriptionByMerchantId: state => merchantId => {
            return state.subscriptions.find(el => el.merchant_id === merchantId)
        },
        getSelectedSubscriptions: state => {
            return state.selectedSubscriptions
        },
        getSubscriptionsSelectAll: state => {
            return state.selectAllSubscriptions
        },
        getFilteredSubscriptions: (state, getters) => {
            if (getters.getMerchantSearch) {
                if (state.subscriptions) {
                    const merchants = getters.getMerchants
                        .filter(item => {
                            return item.name
                                .toLowerCase()
                                .includes(
                                    getters.getMerchantSearch.toLowerCase()
                                )
                        })
                        .map(item => item.id)

                    return state.subscriptions.filter(post => {
                        return merchants.includes(post.merchant_id)
                    })
                }
            } else {
                if (state.subscriptions) {
                    return state.subscriptions
                }
            }
        },
        getSubscriptionsQueue: state => {
            return state.subscriptionsQueue
        },
        getConflictedSubscriptionById: state => id => {
            if (state.conflictedSubscriptions) {
                return state.conflictedSubscriptions.find(
                    item => item.id === id
                )
            }
        },
        getAcceptedSubscriptionById: state => id => {
            if (state.acceptedSubscriptions) {
                return state.acceptedSubscriptions.find(item => item.id === id)
            }
        },
        getSubscriptionsToStop: state => {
            if (state.subscriptionsToStop) {
                return state.subscriptionsToStop.filter(el => !el.suspended)
            }
        },
        getSubscriptionToStopById: state => id => {
            if (state.subscriptionsToStop) {
                return state.subscriptionsToStop.find(item => item.id === id)
            }
        },
        getSelectedSubsToStop: state => {
            if (state.subscriptionsToStop) {
                return state.subscriptionsToStop.filter(el => el.checked)
            }
        },
        getSelectSubsToStop: state => {
            return state.selectSubsToStop
        },
        getSelectedSubscriptionsByPromoId: (state, getters) => (
            promoId,
            groupId
        ) => {
            if (getters.getSelectedPromoGroups) {
                const group = getters.getSelectedPromoGroups.find(
                    group => group.id === groupId
                )
                if (group) {
                    const promo = group.promos.find(
                        promo => promo.id === promoId
                    )
                    const subscriptions = promo.subscriptions.filter(
                        el => el.checked
                    )
                    return subscriptions.length
                } else {
                    return 0
                }
            }
        },
        getSelectedSubscriptionProduct: (state, getters) => (
            promoId,
            productId,
            merchantId,
            groupIdx = null,
            groupId,
            fromLabels
        ) => {
            if (getters.getSelectedPromotions) {
                let searchedSubs

                const promo = getters.getSelectedPromoGroupPromoItem({
                    promoId,
                    groupId
                })

                if (merchantId !== undefined) {
                    searchedSubs = promo.subscriptions
                } else {
                    searchedSubs =
                        promo.subscriptionsEqualPrices.priceGroups[groupIdx]
                }

                let searchedProducts
                if (merchantId !== undefined) {
                    searchedProducts = searchedSubs.find(
                        el => el.merchant_id === merchantId
                    ).products
                } else {
                    searchedProducts = searchedSubs[0].products
                }

                let searchedProduct = null
                if (searchedProducts) {
                    searchedProduct = searchedProducts.find(
                        el => el.productId === productId
                    )
                }

                return searchedProduct
            }
        },
        getSelectedSubscriptionProductSetPrice: (state, getters) => (
            promoId,
            setId,
            merchantId,
            groupIdx = null,
            groupId
        ) => {
            let searchedSubs
            const promo = getters.getSelectedPromoGroupPromoItem({
                promoId,
                groupId
            })

            if (groupIdx !== null) {
                searchedSubs =
                    promo.subscriptionsEqualPrices.priceGroups[groupIdx]
            } else {
                searchedSubs = promo.subscriptions
            }
            let searchedProducts
            if (groupIdx !== null) {
                searchedProducts = searchedSubs[0].product_sets
            } else {
                searchedProducts = searchedSubs.find(
                    el => el.merchant_id === merchantId
                ).product_sets
            }
            const searchedProduct = searchedProducts.find(el => el.id === setId)
            return searchedProduct.price
        },
        getSubscriptionsProgress: state => {
            return state.progress
        },
        getProcessedSubscriptionByType: state => type => {
            return state.processedSubscriptions[type]
        },
        getProcessedSubscriptionsTotal: state => {
            return state.processedSubscriptions.total
        },
        getAcceptedSubscriptionsPagination: state => {
            return state.processedSubscriptions.accepted.pagination
        },
        getInterruptedSubscriptionsPagination: state => {
            return state.processedSubscriptions.interrupted.pagination
        },
        getErrorSubscriptionsPagination: state => {
            return state.processedSubscriptions.error.pagination
        },
        getGeneratedLabelsStatus: state => state.generatedLabelsStatus,
        isLocalCodeInvalid: (state, getters) => (
            promoId,
            groupId,
            merchantId,
            code
        ) => {
            if (merchantId) {
                return !!getters.getLocalCodesErrors.find(
                    el =>
                        el.promoId === promoId &&
                        el.groupId === groupId &&
                        el.merchantId === merchantId &&
                        el.code === code
                )
            } else {
                return !!getters.getLocalCodesErrors.find(
                    el =>
                        el.promoId === promoId &&
                        el.groupId === groupId &&
                        el.code === code
                )
            }
        },
        getSubscriptionsByPromo: (state, getters) => promo => {
            const equalPrices = promo.subscriptionsEqualPrices.equalPrices
            const equalLocalCodes = promo.equalLocalCodes
            let subscriptions = []
            // normal subscriptions
            const nSubscriptions = promo.subscriptions
            // pricegroups subscriptions
            const pSubscriptions = []
            const priceGroups = promo.subscriptionsEqualPrices.priceGroups

            for (let i = priceGroups.length - 1; i >= 0; i--) {
                for (const sub of priceGroups[i]) {
                    const findSub = pSubscriptions.find(s => s.id === sub.id)
                    if (!findSub) {
                        pSubscriptions.push(sub)
                    }
                }
            }

            if (priceGroups?.length) {
                if (equalPrices) {
                    if (equalLocalCodes) {
                        subscriptions = pSubscriptions
                    } else {
                        for (const pSub of pSubscriptions) {
                            // if not equalLocalCodes, overwrite products alternative_eans
                            const nSub = nSubscriptions.find(
                                s => s.id === pSub.id
                            )
                            if (pSub.products) {
                                for (const product of pSub.products) {
                                    const findProduct = nSub.products.find(
                                        p => p.id === product.id
                                    )
                                    product.alternativeEan =
                                        findProduct.alternativeEan
                                }
                            }
                            // pSub.checked = nSub.checked
                            subscriptions.push(pSub)
                        }
                    }
                } else {
                    if (equalLocalCodes) {
                        for (const pSub of pSubscriptions) {
                            // if equalLocalCodes, overwrite products prices
                            const nSub = nSubscriptions.find(
                                s => s.id === pSub.id
                            )
                            if (pSub.products) {
                                for (const product of pSub.products) {
                                    const findProduct = nSub.products.find(
                                        p => p.id === product.id
                                    )
                                    product.productPrice =
                                        findProduct.productPrice
                                }
                            }
                            // nSub.checked = pSub.checked
                            subscriptions.push(pSub)
                        }
                    } else {
                        subscriptions = nSubscriptions
                    }
                }
            } else {
                subscriptions = nSubscriptions
            }

            return subscriptions
        },
        getLocalCodeError: (state, getters) => payload => {
            const errors = getters.getLocalCodesErrors

            return errors.find(el => {
                let allFieldsMatch = true

                for (const field in payload) {
                    if (
                        payload[field] !== undefined &&
                        el[field] !== payload[field]
                    ) {
                        allFieldsMatch = false
                        break
                    }
                }

                return allFieldsMatch
            })
        },

        getLocalCodesErrors: (state, getters) => {
            const errors = []

            const groups = getters.getSelectedPromoGroups

            for (const group of groups) {
                for (const promo of group.promos) {
                    if (!promo.selected) continue

                    if (promo.all_eans_present) continue

                    if (promo.equalLocalCodes) {
                        const priceGroups =
                            promo.subscriptionsEqualPrices.priceGroups
                        for (const subs of priceGroups) {
                            findSubs(subs, group, promo)
                        }
                    } else {
                        findSubs(promo.subscriptions, group, promo)
                    }
                }
            }

            function findSubs(subscriptions, group, promo) {
                subscriptions = subscriptions.filter(
                    el => el.checked || el.checked === undefined
                )
                subscriptions.forEach(sub => {
                    if (!sub.products || !sub.products.length) {
                        errors.push({
                            type: 'noProducts',
                            error: '',
                            groupId: group.id,
                            promoId: promo.id,
                            merchantId: sub.merchant_id,
                            subscriptionId: sub.id
                        })
                        return
                    }

                    const emptyEans = sub.products.some(
                        p => !p.alternativeEan || p.alternativeEan === ''
                    )
                    if (emptyEans) {
                        for (const product of sub.products) {
                            if (product.ean_present || product.alternativeEan) {
                                continue
                            }

                            if (
                                !product.alternativeEan ||
                                product.alternativeEan === ''
                            ) {
                                errors.push({
                                    type: 'emptyEan',
                                    error: '',
                                    code: product.alternativeEan,
                                    productId: product.id,
                                    groupId: group.id,
                                    promoId: promo.id,
                                    merchantId: sub.merchant_id,
                                    subscriptionId: sub.id
                                })
                            }
                        }
                    }

                    const duplicates = []

                    for (const { alternativeEan } of sub.products) {
                        const findDuplicates = sub.products.filter(d => {
                            return (
                                d.alternativeEan &&
                                d.alternativeEan === alternativeEan
                            )
                        })
                        if (findDuplicates.length > 1) {
                            duplicates.push(...findDuplicates)
                        }
                    }
                    const dSet = [...new Set(duplicates)]

                    dSet.forEach(product => {
                        errors.push({
                            type: 'duplicateEan',
                            error: 'Kod musi być unikalny',
                            code: product.alternativeEan,
                            productId: product.id,
                            groupId: group.id,
                            promoId: promo.id,
                            merchantId: sub.merchant_id,
                            subscriptionId: sub.id
                        })
                    })
                })
            }

            return errors
        },
        getLocalCodesDuplicates: (state, getters) => {
            return getters.getLocalCodesErrors.filter(
                el => el.type === 'duplicateEan'
            )
        },
        getMandatoryPriceErrors: (state, getters) => type => {
            const errors = []

            const groups = getters.getSelectedLabelGroups

            for (const group of groups) {
                for (const promo of group.promos) {
                    if (!promo.selectedToGenerateLabels) continue
                    if (promo.subscriptionsEqualPrices.equalPrices) {
                        const priceGroups =
                            promo.subscriptionsEqualPrices.priceGroups
                        for (const subs of priceGroups) {
                            findSubs(subs, group, promo)
                        }
                    } else {
                        findSubs(promo.subscriptions, group, promo)
                    }
                }
            }

            function findSubs(subscriptions, group, promo) {
                subscriptions = subscriptions.filter(
                    el => el.checked || el.checked === undefined
                )
                subscriptions.forEach(sub => {
                    if (!sub.products || !sub.products.length) {
                        errors.push({
                            type: 'noProducts',
                            error: '',
                            groupId: group.id,
                            promoId: promo.id,
                            merchantId: sub.merchant_id,
                            subscriptionId: sub.id
                        })
                        return
                    }
                    if (type === 'noPriceLowest') {
                        const noPriceLowest = sub.products.some(
                            p => !p.price_lowest && p.downloadLabel
                        )
                        if (noPriceLowest) {
                            for (const product of sub.products) {
                                const priceLowest =
                                    product.priceLowest || product.price_lowest
                                if (
                                    product.downloadLabel &&
                                    (!priceLowest || +priceLowest === 0)
                                ) {
                                    errors.push({
                                        type: 'noPriceLowest',
                                        error: '',
                                        productId: product.id,
                                        groupId: group.id,
                                        promoId: promo.id,
                                        merchantId: sub.merchant_id,
                                        subscriptionId: sub.id
                                    })
                                }
                            }
                        }
                    } else if (type === 'noPriceNormal') {
                        const noPriceNormal = sub.products.some(
                            p => !p.productPrice && p.downloadLabel
                        )

                        if (noPriceNormal) {
                            for (const product of sub.products) {
                                if (
                                    product.downloadLabel &&
                                    (!product.productPrice ||
                                        !(+product.productPrice > 0))
                                ) {
                                    errors.push({
                                        type: 'noPriceNormal',
                                        error: '',
                                        productId: product.id,
                                        groupId: group.id,
                                        promoId: promo.id,
                                        merchantId: sub.merchant_id,
                                        subscriptionId: sub.id
                                    })
                                }
                            }
                        }
                    } else if (type === 'noWeightPriceNormal') {
                        const noWeightPriceNormal = sub.products.some(
                            p =>
                                !(
                                    p.payload && p.payload.price_lowest_discount
                                ) && p.downloadLabel
                        )
                        if (noWeightPriceNormal) {
                            for (const product of sub.products) {
                                if (
                                    product.downloadLabel &&
                                    (!product.payload ||
                                        !product.payload
                                            .price_lowest_discount ||
                                        !(
                                            +product.payload
                                                .price_lowest_discount > 0
                                        ))
                                ) {
                                    errors.push({
                                        type: 'noWeightPriceNormal',
                                        error: '',
                                        productId: product.id,
                                        groupId: group.id,
                                        promoId: promo.id,
                                        merchantId: sub.merchant_id,
                                        subscriptionId: sub.id
                                    })
                                }
                            }
                        }
                    }
                })
            }

            return errors
        },
        getMandatoryPriceError: (state, getters) => payload => {
            const errors = getters.getMandatoryPriceErrors(payload.type)
            return errors.find(el => {
                let allFieldsMatch = true

                for (const field in payload) {
                    if (
                        payload[field] !== undefined &&
                        el[field] !== payload[field]
                    ) {
                        allFieldsMatch = false
                        break
                    }
                }

                return allFieldsMatch
            })
        },
        getSubscriptionLocalCodeErrors: state => {
            return state.subscriptionLocalCodeErrors
        }
    }
}
